import Link from 'next/link'
import React from 'react'
import { useRouter } from 'next/router'
import { ParsedUrlQueryInput } from 'querystring'
import { getLinkWithQuery } from '../src/model/urls'

export interface CurrentLinkProps {
	query: ParsedUrlQueryInput
}

export const CurrentLink: React.FC<CurrentLinkProps> = ({
	children,
	query,
}) => {
	const router = useRouter()
	const linkProps = React.useMemo(() => {
		return getLinkWithQuery(
			{
				as: router.asPath,
				href: {
					pathname: router.pathname,
					query: router.query,
				},
			},
			query,
		)
	}, [query, router.asPath, router.pathname, router.query])
	return <Link {...linkProps}>{children}</Link>
}
